import {Inject, Injectable, Optional} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../../util/codecs/encoder';

import {Observable} from 'rxjs';

import {ApiService} from '../../util/api.service';
import {environment} from '../../../../../environments/environment';
import {HeadersRequest} from '../../util/model/header-request.inteface';

@Injectable()
export class OrdemService {

  private basePath = environment.basePathOrquestrador;

  constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  public consultarOrdens(limit: number, offset: number, nroProcesso?: string, authorization?: string): Observable<any> {

    if (limit === null || limit === undefined)
      throw new Error('Required parameter limit was null or undefined when calling consultarOrdens.');
    if (offset === null || offset === undefined)
      throw new Error('Required parameter offset was null or undefined when calling consultarOrdens.');
    if (authorization === null || authorization === undefined)
      throw new Error('Required parameter authorization was null or undefined when calling changeApp.');

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParameters = queryParameters.set('limit', limit.toString());
    queryParameters = queryParameters.set('offset', offset.toString());

    if (nroProcesso)
      queryParameters = queryParameters.set('nroProcesso', nroProcesso);

    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
    headers.push({param: 'Content-Type', value: 'application/json'});

    const uri: string = environment.ordem.consultarOrdens;
    return this.apiService.get<any>(this.basePath + uri,queryParameters, headers );
  }


  public findByNroProcesso(nroProcesso: string, tipoOrdem: string[], authorization?: string): Observable<any> {

    const headers: Array<HeadersRequest> = [
      { param: 'Authorization', value: 'Bearer ' + authorization }
    ];

    let queryParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    tipoOrdem.forEach(tipo => {
      queryParams = queryParams.append('tipoOrdem', tipo);
    });

    const uri: string = `${this.basePath}/ordens/${nroProcesso}/ultima`;
    return this.apiService.get<any>(uri, queryParams, headers);
  }

  public detalharOrdem(ordem: any, authorization?: string): Observable<any> {
    if ((!ordem.nroOrdem && !ordem.anoOrdem) && !ordem.id)
      throw new Error('Required parameter was null or undefined when calling detalharOrdem.');

    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
    headers.push({param: 'Content-Type', value: 'application/json'});

    let params = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if(ordem.sistemaOrigem === 'SJ1'){
      params = params.set('numeroOficioJudicial', ordem.nroOrdem);
      params = params.set('anoOficioJudicial', ordem.anoOrdem);
    } else {
      params = params.set('id', ordem.id);
    }

    params = params.set('sistemaOrigem', ordem.sistemaOrigem);

    const uri: string = `${this.basePath}/ordens/detalhe`;
    return this.apiService.get<any>(uri, params, headers);
  }

}
